import { connect } from 'react-redux';
import TreatmentFilterBox from '../../../components/DailyPlanning/TreatmentFilterBox/TreatmentFilterBox';
import {
  setTreatmentInstanceSorting,
  updateFiltersAndRefresh,
  autoAllocate,
  autoUnallocate,
  refreshScheduler,
} from '../../../actions/areas/dailyPlanning';
import { getServicesDetails } from '../../../actions/areas/dailyPlanning/serviceDetails';
import {
  getDefaultOrgUnitForDay,
  getPostings,
  getTreatmentInstances,
  getCurrentUserOrgUnits,
  resetPostings,
} from '../../../actions/entities';
import { getSelectorOptions } from '../../../actions/uiElements/selectors';
import { bandsEndpoint, autoAllocationStatuses } from '../../../settings/constants';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';

export function buildHierarchy(teamStructure = {}, startLevel, startId) {
  const result = {};

  if (!teamStructure[0]) {
    return { [startLevel]: startId };
  }

  try {
    for (let i = startLevel; i >= 0; i -= 1) {
      if (i === startLevel) {
        result[i] = startId;
      } else {
        result[i] = teamStructure[i + 1][result[i + 1]].parent;
      }
    }
    return result;
  } catch (error) {
    return { error };
  }
}

const mapStateToProps = ({ areas: { dailyPlanning }, entities: { orgUnits, postings }, global: { auth } }) => {
  const { filters, selectedDate, treatmentInstanceSorting: sorting } = dailyPlanning;
  return {
    sorting,
    orgStructureDepth: filters.orgStructureDepth,
    teams: orgUnits.general.teams,
    isFetching: orgUnits.general.isFetching,
    selectedHierarchy: buildHierarchy(orgUnits.general.entities, filters.orgStructureDepth - 1, filters.selectedTeam),
    serverDateTime: postings.general.serverDateTime,
    selectedTeam: filters.selectedTeam,
    selectedDate,
    isAllocating: dailyPlanning.autoAllocate.isAllocating,
    isUnAllocating: dailyPlanning.autoAllocate.isUnAllocating,
    autoAllocationStatus: dailyPlanning.autoAllocate.status || autoAllocationStatuses.IDLE,
    autoAllocationProgress: dailyPlanning.autoAllocate.progress,
    autoAllocateDate: dailyPlanning.autoAllocate.date,
    autoAllocateTeamId: dailyPlanning.autoAllocate.teamId,
    autoAllocationTeamName: dailyPlanning.autoAllocate.teamName,
    autoAllocationHeartBeat: dailyPlanning.autoAllocate.heartBeat,
    createAutoAllocationLog: dailyPlanning.autoAllocate.createLog,
    syncProgress: dailyPlanning.autoAllocate.syncProgress,
    canAllocateWork: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canAllocateWork),
    isNightMode: dailyPlanning.scheduler.isNightMode,
  };
};

const mapDispatchToProps = (dispatch, { selectedDate }) => ({
  setSorting: sorting =>
    dispatch(
      setTreatmentInstanceSorting({
        orderBy: sorting[0].name,
        orderDir: sorting[0].clickedBefore ? 'desc' : 'asc',
      }),
    ),
  updateFilters: filter => dispatch(updateFiltersAndRefresh(filter)),
  noTeamStructureEscape: async () => {
    try {
      await dispatch(getDefaultOrgUnitForDay(selectedDate));
      await dispatch(getSelectorOptions(bandsEndpoint, 'bands'));
      await dispatch(getCurrentUserOrgUnits(selectedDate));
      dispatch(getPostings(true));
      dispatch(getTreatmentInstances(true));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  },
  autoAllocate: queryData => {
    dispatch(resetPostings());
    dispatch(autoAllocate(queryData));
  },
  autoUnallocate: queryData => dispatch(autoUnallocate(queryData)),
  getServicesDetails: () => dispatch(getServicesDetails()),
  refreshScheduler: () => dispatch(refreshScheduler()),
});

const VisibleTreatmentFilterBox = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TreatmentFilterBox);

export default VisibleTreatmentFilterBox;
